<script setup lang="ts">
import type { PressPage } from 'storyblok/types/pages'

interface PressArticleItem {
  slug: string
  content: {
    title: string
    publishDate: Date
    perex: StoryBlokRichText
  }
}

const sbApi = useStoryblokApiV2()
const data: StoryblokPage = await sbApi.getPage()
const pageData = data.customPage[0] as PressPage
const pressArticles = (await sbApi.getStories<PressArticleItem>({
  by_slugs: ['pages/press/*'],
  sort_by: 'content.publishDate:desc',
  per_page: 3,
  is_startpage: false,
}))?.stories

useStoryblokMeta(data)
</script>

<template>
  <div>
    <section class="bg-gradient md:text-center pt-5 pb-10">
      <div class="content-container">
        <AppBreadcrumbs />
        <h1 class="mt-5">
          {{ pageData.title }}
        </h1>
        <StoryblokRichText class="text-large" :document="pageData.subtitle" />
      </div>
    </section>
    <PressContact class="bg-background" v-bind="pageData" />
    <section class="bg-white content-container py-35px md:py-70px md:text-center">
      <h2>{{ pageData.title3 }}</h2>
      <div class="flex flex-col gap-5 mt-5 md:flex-row">
        <StoryblokLink
          v-for="item in pageData.items1"
          v-editable="item"
          class="p-5 flex items-center link-tile gap-5 rounded-xl w-full md:block"
          v-bind="item.link"
        >
          <AppIcon class="md:mx-auto text-primary" v-bind="item.icon" size="50" msize="30" />
          <span class="headline-3">{{ item.text }}</span>
        </StoryblokLink>
      </div>
    </section>
    <section class="bg-background md:text-center py-70px">
      <div class="content-container">
        <h2>{{ pageData.articlesTitle }}</h2>
        <div class="max-w-780px mt-5 mx-auto mb-70px flex flex-col gap-5">
          <PressArticle v-for="{ slug, content: article } in pressArticles" :key="slug" :slug="slug" v-bind="article" />
          <StoryblokButton v-bind="pageData.allArticlesButton[0]" />
        </div>
        <h2>{{ pageData.title4 }}</h2>
        <div class="flex flex-col gap-5 mt-5 md:flex-row">
          <StoryblokLink
            v-for="item in pageData.items2"
            v-editable="item"
            class="p-5 flex items-center link-tile gap-5 rounded-xl w-full bg-white md:block"
            v-bind="item.link"
          >
            <AppIcon class="md:mx-auto text-primary" v-bind="item.icon" size="50" msize="30" />
            <span class="headline-3">{{ item.text }}</span>
          </StoryblokLink>
        </div>
      </div>
    </section>
  </div>
</template>
